import React, { createElement } from 'react';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { formatImage } from '@ifeng/public_method'
import Chip from 'Chip';

export interface SupportProps {
    style?: object,
    supportChip: TYPE_Chip
    rightsName: string // 版权名称
    rightsUrl: string // 版权链接
}

const Support:React.FC<SupportProps> = (props) => {
    const { supportChip, rightsName, rightsUrl, style } = props

    const supportChipData = useChip(supportChip)
    const chipComponentData = formatChip(supportChip)

    return (
        <Chip {...chipComponentData}>
            <div className={Style.supportWp} style={style}>
                <div className={Style.supportList}>
                    {
                        supportChipData.map((item, index) => {
                            return (
                                <div className={Style.support} key={index}>
                                    <div className={Style.title}>{item.title}</div>
                                    {
                                        item.imageList.map((image, idx) => {
                                            return (
                                                <div className={Style.image} key={`${index}_${idx}`}>
                                                    <a href={image.url} target="_blank" rel="noreferrer">
                                                        <img src={formatImage(image.image, undefined, 80)} alt="" />
                                                    </a>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            );
                        })
                    }
                </div>
                <div className={Style.rights}>
                    <div className={Style.title}>版权声明</div>
                    <div className={Style.title} style={{ paddingLeft: '10px' }}>
                        凤凰网 <a href={rightsUrl} target="_blank">{rightsName}</a> 中心出品
                    </div>
                </div>
                <Mask visible={!supportChip.id} zIndex={3}>
                    示例结构化碎片—{supportChip.default.id}
                </Mask>
            </div>
        </Chip>
    );
}

export default Support;
